import { registerComponent } from '@gig/magic-common';
import WalletContentComponent from './wallet-content.vue.js';

var WalletContent = registerComponent(WalletContentComponent);

export { WalletContent };
